<template>
  <el-dialog
    title="编辑支付"
    :visible="visibleInside"
    @close="$emit('close')"
    width="400px"
    :close-on-click-modal="false"
    center
  >
    <el-form
      :model="formData"
      :rules="rules"
      ref="paymentForm"
      label-width="100px"
    >
      <el-form-item prop="category_id" label="支付分组">
        <el-select v-model="formData.category_id" placeholder="请选择支付分组">
          <el-option :value="0" label="无"></el-option>
          <el-option
            v-for="item in groupsList"
            :key="item.id"
            :value="item.id"
            :label="item.name"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="probability" label="分组概率">
        <el-input v-model="formData.probability"></el-input>
      </el-form-item>
      <el-divider></el-divider>
      <el-form-item prop="show_name" label="支付名称">
        <el-input v-model="formData.show_name"></el-input>
      </el-form-item>
      <el-form-item prop="pay_type" label="支付类型">
        <el-select v-model="formData.pay_type">
          <el-option label="支付宝" :value="1"></el-option>
          <el-option label="微信" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="image" label="支付图标">
        <ImgUpload v-model="formData.image"></ImgUpload>
      </el-form-item>
      <el-form-item prop="unchecked_image" label="未选中图标">
        <ImgUpload v-model="formData.unchecked_image"></ImgUpload>
      </el-form-item>
      <el-form-item prop="show_type" label="显示类型">
        <el-select v-model="formData.show_type">
          <el-option label="不显示" :value="0"></el-option>
          <el-option label="电脑手机都显示" :value="1"></el-option>
          <el-option label="仅电脑显示" :value="2"></el-option>
          <el-option label="仅手机显示" :value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="is_open" label="支付开关">
        <el-radio v-model="formData.is_open" :label="1">开</el-radio>
        <el-radio v-model="formData.is_open" :label="0">关</el-radio>
      </el-form-item>
      <el-form-item prop="is_time_switch" label="时段开关">
        <el-radio v-model="formData.is_time_switch" :label="1">开</el-radio>
        <el-radio v-model="formData.is_time_switch" :label="0">关</el-radio>
      </el-form-item>
      <el-form-item prop="single_max_amount" label="单笔最大金额">
        <el-input v-model="formData.single_max_amount"></el-input>
      </el-form-item>
      <el-form-item prop="day_max_amount" label="每天最大金额">
        <el-input v-model="formData.day_max_amount"></el-input>
      </el-form-item>
      <el-form-item prop="hour_max_amount" label="每时最大金额">
        <el-input v-model="formData.hour_max_amount"></el-input>
      </el-form-item>
      <el-form-item prop="sort" label="支付权重">
        <el-input v-model="formData.sort"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="$emit('close')">取 消</el-button>
      <el-button
        size="small"
        type="primary"
        @click="submit"
        :loading="buttonLoading"
        >确 定</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
import { patchData, getApiData, patchApiData } from '@/http'
import ImgUpload from '@/components/common/ImgUpload.vue'

const validateTime = (rule, value, callback) => {
  let lastEnd
  for (let item of value) {
    lastEnd = item.end
    if (lastEnd && item.end < lastEnd) {
      callback(new Error('开始时间不能小于或等于上一个结束时间'))
      break
    }
    if (item.end === undefined || item.start === undefined) {
      callback(new Error('请输入正确的时间(0-24小时)'))
      break
    } else if (item.end <= item.start) {
      callback(new Error('开始时间不能小于或等于结束时间'))
      break
    }
  }
  callback()
}

export default {
  components: {
    ImgUpload
  },
  props: {
    visible: Boolean,
    defaultValues: Object,
    id: Number
  },
  data() {
    return {
      buttonLoading: false,
      formData: {
        category_id: '',//支付分组
        probability: '',//分组概率
        day_max_amount: 0,
        hour_max_amount: 0,
        image: '',
        unchecked_image: '',
        show_type: '',
        is_open: 0,
        is_time_switch: 0,
        pay_type: '',
        show_name: '',
        single_max_amount: 0,
        sort: '',
      },
      groupsList: undefined,//分组列表
      rules: {
        category_id: [
          {
            required: true,
            message: '支付分组不能为空',
            trigger: 'blur'
          }
        ],
        probability: [
          {
            required: true,
            message: '分组概率不能为空',
            trigger: 'blur'
          }
        ],
      }
    }
  },
  computed: {
    visibleInside: {
      get() {
        return this.visible
      },
      set() { }
    }
  },
  watch: {
    visibleInside(val) {
      if (val) {
        this.getGroups()//拿取分组信息
      } else {
        this.$refs.paymentForm.resetFields()
      }
    },
    defaultValues(val) {
      if (val) {
        this.formData = val
      }
    }
  },
  methods: {
    getGroups() {
      //获取分组列表
      getApiData(`pay_category`)
        .then(
          res => {
            this.groupsList = res
          }
        )
    },
    submit() {
      this.$refs.paymentForm.validate(valid => {
        if (valid) {
          if (!this.formData.category_id) {
            this.$message.error("请选择支付分组")
            return
          }
          if (!this.formData.probability) {
            this.$message.error("请选择分组概率")
            return
          }
          this.buttonLoading = true
          let params = this.formData
          patchApiData(`pay_configs/${this.id}`, params)
            .then(
              res => {
                this.$message.success('修改成功')
                this.$emit('close')
                this.$emit('refresh')
              }
            )
            .finally(() => {
              this.buttonLoading = false
            })
        }
      })
    }
  }
}
</script>
